const DEFAULT_CABIN_CLASS = "economy";
export const CABIN_CLASS_TYPES = new Set([
  "economy",
  "premiumeconomy",
  "business",
]);

export function getDefaultCabinClass(searchParams: URLSearchParams) {
  const searchCabinClass = searchParams.get("cabinClass")?.toLowerCase();
  return CABIN_CLASS_TYPES.has(searchCabinClass ?? "")
    ? searchCabinClass
    : DEFAULT_CABIN_CLASS;
}
